import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AGENTS, AgentDef } from './agentConfig';
import backArrow from "../../assets/task/back_arrow.svg";
import BreadCumb from '../../components/common/Breadcrumb';

const LockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="11" width="18" height="11" rx="2" stroke="#526484" strokeWidth="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="#526484" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const Agents: React.FC = () => {
  const navigate = useNavigate();

  const handleAgentClick = (agent: AgentDef) => {
    if (!agent.enabled) return;
    navigate(`/agent/${agent.id}`, { state: { agent } });
  };

  return (
    <div id="cts-respon-p-dv" className="w-full  relative  overflow-hidden contain flex-row items-start justify-center flex-wrap content-start py-40 px-20 mq991:p-8 mq575:p-4  box-border text-left text-base text-gray font-manrope">
      <div className="flex-1 flex flex-col items-start justify-start gap-6 mb-6">
        <BreadCumb />
        <div className="self-stretch flex flex-row items-center justify-start gap-[5px] text-2xl">
          <img className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img" alt="" src={backArrow}
            onClick={() => navigate(-1)}
          />
          <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit inline-block max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">AI Team</h3>
        </div>
      </div>


      <section
        id="agents-team"
        className="m-0 self-stretch rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove flex flex-col items-start justify-start p-8 mq575:p-3 box-border gap-spacing-lg max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border"
      >

        <div className="grid grid-cols-3 mq630:grid-cols-2 mq450:grid-cols-1 gap-6 min-w-full w-full">
          {AGENTS.map((agent) => (
            <div
              key={agent.id}
              role={agent.enabled ? 'button' : undefined}
              tabIndex={agent.enabled ? 0 : undefined}
              onKeyDown={agent.enabled ? (e) => e.key === 'Enter' && handleAgentClick(agent) : undefined}
              onClick={() => handleAgentClick(agent)}
              className={[
                'relative rounded-xl overflow-hidden shadow-md select-none',
                agent.enabled
                  ? 'cursor-pointer transition-transform hover:scale-[1.03] hover:shadow-xl'
                  : 'cursor-not-allowed',
              ].join(' ')}
            >
              {/* Avatar area */}
              <div
                className="relative w-full flex items-end justify-center"
                style={{
                  height: 200,
                  background: `linear-gradient(160deg, ${agent.avatarColor}dd 0%, ${agent.avatarColor}88 100%)`,
                }}
              >
                <span
                  className="absolute inset-0 flex items-center justify-center text-white font-bold select-none"
                  style={{ fontSize: 72, opacity: 0.18 }}
                >
                  {agent.initials}
                </span>

                {/* Name overlay at bottom of photo */}
                <div
                  className="relative z-10 w-full px-3 pb-2 pt-6"
                  style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 100%)' }}
                >
                  <p className="text-white-custom text-sm font-medium text-center drop-shadow-sm">
                    {agent.name}
                  </p>
                </div>
              </div>

              {/* Role label */}
              <div className="bg-white px-3 py-2.5 text-center font-bold">
                <p className="my-0 text-xl-dv self-stretch relative text-lg">{agent.role}</p>
              </div>

              {/* Lock overlay */}
              {!agent.enabled && (
                <div className="absolute top-2.5 left-2.5">
                  <div
                    className="rounded-full p-1.5 shadow-sm"
                    style={{ background: 'rgba(255,255,255,0.92)' }}
                  >
                    <LockIcon />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Agents;
